import { normalizeInternalAppUrl } from "@dcc/vestas-online/auth/data-access";

export function createStartupRetryUrl(value: string | null | undefined): string {
    return `${window.location.origin}${normalizeInternalAppUrl(value)}`;
}
